<enhanced-help componentName="rpa-type-list" [compact]="true"> </enhanced-help>
<div class="container-scroll">
    <div class="horizontal-container">
        <button
            *ngIf="canEdit && !readOnly"
            type="button"
            class="btn-circle btn-link"
            [disabled]="working"
            (click)="createRpaType()"
            tooltip="Create RPA type"
            placement="left"
        >
            <span class="fa fa-plus"></span>
        </button>
        <div class="fill">
            <static-table
                *ngIf="rpaTypes != null && rpaTypes.length > 0"
                [availableColumns]="availableColumns"
                [selectedColumns]="selectedColumns"
                [tableData]="rpaTypes"
                [tableConfig]="tableConfig"
                [columnSorting]="columnSorting"
                (selectedColumnsChanged)="
                    updateSelectedColumns($event.selectedColumns)
                "
                (sortOrderChanged)="updateColumnSorting($event)"
            >
            </static-table>
        </div>
    </div>
    <loading-indicator
        class="pull-left"
        [isLoading]="working"
    ></loading-indicator>
</div>
